import { motion } from "framer-motion";
import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { config } from "@core/config/config";
import { useServices } from "@core/servicesContext";
import { ArrowIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";
import { mobile, TOP_BAR_OFFSET, TOP_BAR_OFFSET_MOBILE } from "@ui/styles/utils";
import { Z } from "@ui/styles/zIndex";
import { useNewContentUpdate } from "./useNewContentUpdate";

interface NewContentIncentiveProps extends React.HTMLAttributes<HTMLDivElement> {
	isMoustache?: string;
}
export const NewContentIncentive: React.FC<NewContentIncentiveProps> = () => {
	const newContent = useNewContentUpdate();
	const { postService } = useServices();

	return newContent ? (
		<Container
			$isMoustache={config.features.banner}
			initial={{ x: "-50%", y: -120 }}
			animate={{ x: "-50%", y: 0 }}
			onClick={() => {
				window.scrollTo({ top: 0 });
				postService.fetchFeed();
			}}
		>
			<ArrowIcon />
			<div>{I18n.t("home.new_content.incentive")}</div>
		</Container>
	) : null;
};

const Container = styled(motion.div)<{ $isMoustache?: boolean }>`
	position: fixed;
	cursor: pointer;
	${({ $isMoustache }) => ($isMoustache ? `top: 120px` : `top: ${TOP_BAR_OFFSET}px; `)}
	/* top: ${TOP_BAR_OFFSET}px; */
	@media ${mobile} {
		/* top: ${TOP_BAR_OFFSET_MOBILE}px; */
		${({ $isMoustache }) => ($isMoustache ? `top: 130px` : `top: ${TOP_BAR_OFFSET_MOBILE}px; `)}
	}
	left: 50%;
	transform: translateX(-50%);
	padding: 6px 10px;
	border-radius: 13px;
	background-color: ${({ theme }) => theme.colors.primary};
	z-index: ${Z.toolbar - 1};
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.white};
	${row(4, "flex-start", "center")};

	> svg {
		transform: rotate(90deg);
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`;
